export enum FormEditMode {
  WEBONLY = 'WEBONLY',
  WEB_AND_APP = 'WEB_AND_APP',
  OFFLINE = 'OFFLINE',
}

export const FormEditModeMap = {
  [FormEditMode.WEBONLY]: '网页',
  [FormEditMode.WEB_AND_APP]: '网页+App',
  [FormEditMode.OFFLINE]: '线下',
};

export const FormEditModeList = [
  {
    value: FormEditMode.WEBONLY,
    label: FormEditModeMap[FormEditMode.WEBONLY],
  },
  {
    value: FormEditMode.WEB_AND_APP,
    label: FormEditModeMap[FormEditMode.WEB_AND_APP],
  },
  {
    value: FormEditMode.OFFLINE,
    label: FormEditModeMap[FormEditMode.OFFLINE],
  },
];
